import React, { useState } from "react";
import "./Styles.css";
import { Button } from '@mui/material';
import { Forms } from "./Forms";
import { Endpoints } from "./Endpoints";
import { useParams, Link } from "react-router-dom";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {SaveAlert} from "./SaveAlert";
import ApiConfig from '../../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../../utils/hooks';

function EpComponent(props) {
  const { name } = useParams();
  // const { endpts, robotSelectedEp, onFetchEndpoints, onFetchAssignedEndpoints } = location.state || {};
  const [robot, setRobot] = useState({})
  const [endpts, setEndpts] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [editEndpoint, setEditEndpoint] = useState(null);
  const [selectedEp, setSelectedEp] = useState([]); // array of selected ep names
  const [submitAlert, setSubmitAlert] = useState(null);
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()

  const initRetrieve = () => {
    Promise.all([
        apiConfig.fetchAllEndpoints(),
        apiConfig.fetchRobotData(0),
        apiConfig.fetchAllAssignedEndpoints(),
    ]).then(results => {
        console.log(results[0].RobotResponse)
        setEndpts(results[0].RobotResponse);
        var currentRobot = {}
        for(let i = 0; i < results[1].RobotResponse.length; i++) {
          if(results[1].RobotResponse[i].RobotId === name){
              setRobot(results[1].RobotResponse[i])
              currentRobot = results[1].RobotResponse[i]
              break;
          }
        }
        const formattedSelectedEp = [];
        results[2].RobotResponse.forEach(item => {
            if (String(item.RobotTableId) === String(currentRobot.Id)){
              var robotEndpt = null
              results[0].RobotResponse.forEach(endpt => {
                if(String(endpt.Id) === String(item.RobotEndpointId)){
                  robotEndpt = endpt
                }
              });
                formattedSelectedEp.push(robotEndpt);
            }
        });
        setSelectedEp(formattedSelectedEp);
    }).catch(error => {
        console.error(error);
    });
  }

  useMountEffect(() => {
    initRetrieve()
  }, []);

  // const onFetchEndpoints = () => {
  //   setRobots([])
  //   // setRobotStatus([])
  //   // setRobotLaser([])
  //   Promise.all([
  //     apiConfig.fetchRobotData(0)
  //   ]).then(results => {
  //     var robot_table = results[0].RobotResponse
  //     console.log(robot_table)
  //     for(let i = 0; i < robot_table.length; i++) {
  //       getRobotInfoById(robot_table[i])
  //     }
  //   }).catch(error => {
  //       console.error(error);
  //   });
  // }

  const handleSubmitYes = (newData) => {
    // if edit ep button is clicked
    if (editEndpoint) {
      Promise.all([
          apiConfig.updateEndpoint(editEndpoint.Id, newData),
      ]).then(results => {
        setEditEndpoint(null);
        setOpenForm(false);
        initRetrieve()
      }).catch(error => {
          console.error(error);
      });

    }
    // if adding new ep button is clicked
    else {
      // createEndpoint(newData);
      Promise.all([
        apiConfig.createEndpoint(newData),
      ]).then(results => {
        setOpenForm(false);
        initRetrieve()
      }).catch(error => {
          console.error(error);
      });
      // setOpenForm(false);
    }
    console.log("Reinit")
    setSubmitAlert(null)
  };

  const handleSelectedEp = (endpoint) => {
    // if ep in selectedEp then remove it, else include it
    console.log(endpoint);
    const updatedSelectedEp = selectedEp.includes(endpoint)
      ? selectedEp.filter((ep) => ep !== endpoint)
      : [...selectedEp, endpoint];
    // console.log(updatedSelectedEp)
    setSelectedEp(updatedSelectedEp);
  };

  const handleEditEndpoint = (ep) => {
    setEditEndpoint(ep); // changing selected Ep, calls form w new eachEntry
    setOpenForm(true);
  };

  const handleDeleteEndpoint = (endpointId) => {
    Promise.all([
      apiConfig.deleteEndpoint(endpointId),
    ]).then(results => {
      initRetrieve()
    }).catch(error => {
        console.error(error);
    });
  };

  const handleCreateAssignedEndpoint = (assignedEndpoints) => {
    Promise.all([
      apiConfig.deleteAssignedEndpointByRobotTableId({robot_table_id: robot.Id}),
    ]).then(results => {
      // console.log(results[0].RobotResponse)
      assignedEndpoints.forEach(ep=>{
        apiConfig.createAssignedEndpoint({RobotTableId: robot.Id, RobotEndpointId: ep.Id, CreatedBy: "system", UpdatedBy: "system"}).then(result=>{
          // console.log(result.RobotResponse)
          initRetrieve()
        })
      })
    }).catch(error => {
        console.error(error);
    });
  };

  const handleCancelForm = () => {
    setEditEndpoint(null);
    setOpenForm(false);
  }

  const submit = (newData) => {
    setSubmitAlert(newData);
  }

  return (
    <div className="epContainer">
      <div className="TopParts">
        <Button component={Link} to={`/managements/endpoint_management`} variant="contained" className="backButton">
            Back to Robots
        </Button>
        <hr style={{width: '100%',marginTop: '1%' }}/>
        <div className="top">
          <h1>End Points for Robot {name}</h1>
          <Button onClick={(e) => {setOpenForm(true);setEditEndpoint(null);}}
          style={{ borderRadius: 10 , fontSize: "1.5rem", padding: "6px 18px",
          color: "white", backgroundColor: "rgb(55, 99, 221)"}}
          variant="contained"
          startIcon={<AddCircleOutlineIcon style={{ fontSize: 30}}/>}>
            Add New Endpoint
          </Button>
        </div>
      </div>

        <Endpoints
          apiConfig={apiConfig}
          endpts = {endpts}
          onEditEndpoint={handleEditEndpoint}
          selectedEp={selectedEp}
          onSelectEp={handleSelectedEp}
          onDeleteEndpoint={handleDeleteEndpoint}
          onCreateAssignedEndpoint={handleCreateAssignedEndpoint}
        />

        {submitAlert && <SaveAlert onClose={() => {setSubmitAlert(null);}} onYes={() => handleSubmitYes(submitAlert)} heading={"Confirm Submission?"} message={null}/>}
        {openForm && <Forms onSubmit={submit} onCancel={handleCancelForm} editEndpoint={editEndpoint} endpts={endpts}/>}

    </div>
  );
}

export default EpComponent;
